import axios from "axios";
import { toast } from "react-toastify";
import {
  GET_TERMINAL_ASSESSMENT_RANKING,
  GET_TERMINAL_ASSESSMENT_RANKING_LOADING,
  CLEAR_TERMINAL_ASSESSMENT_RANKING,
} from "../constants/Type";
import { BASE_URL } from "../constants/URL";

export const getTerminalAssessmentRanking = (data) => async (dispatch) => {
  try {
    // Dispatch loading start action
    dispatch({
      type: GET_TERMINAL_ASSESSMENT_RANKING_LOADING,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const res = await axios.post(
      `${BASE_URL}/api/terminal/assessment-ranking`,
      JSON.stringify(data),
      config
    );

    dispatch({
      type: GET_TERMINAL_ASSESSMENT_RANKING,
      payload: res.data,
    });

    return res.data;
  } catch (err) {
    // Set loading to false on error as well
    dispatch({
      type: GET_TERMINAL_ASSESSMENT_RANKING,
      payload: null,
    });

    toast.error(err.response?.data?.message || "Error fetching ranking data");
    return false;
  }
};

export const clearTerminalAssessmentRanking = () => {
  return {
    type: CLEAR_TERMINAL_ASSESSMENT_RANKING,
  };
};
